import { ActiveErrorResponse } from '@vi-iot/client';

import { AggregatedStatus } from './../../models/installation.model';
export interface LiveUpdatesCreateSocketResponse {
  path: string;
  url: string;
  validTo: string;
  namespace: string;
  socketId: string;
}

export enum LiveUpdatesSubscriptionType {
  DeviceFeatures = 'device-features',
  GatewayFeatures = 'gateway-features',
  InstallationFeatures = 'installation-features',
  InstallationErrors = 'installation-errors',
  GatewayAggregatedStatus = 'gateway-aggregated-status',
  GatewayOnlineStatus = 'gateway-online-status',
  Installation = 'installation',
  Invitation = 'invitation',
  SmartNote = 'smart-notes',
}

export type LiveUpdatesSubscriptionQuery =
  | LiveUpdatesDeviceFeaturesQuery
  | LiveUpdatesGatewayFeaturesQuery
  | LiveUpdatesInstallationFeaturesQuery
  | LiveUpdatesInstallationErrorsQuery
  | LiveUpdatesGatewayAggregatedStatusQuery
  | LiveUpdatesGatewayOnlineStatusQuery
  | LiveUpdatesInstallationQuery
  | LiveUpdatesInvitationQuery
  | LiveUpdatesSmartNoteQuery;

export interface LiveUpdatesDeviceFeaturesQuery {
  id: string; // deviceSerial
  type: LiveUpdatesSubscriptionType.DeviceFeatures;
  gatewayId: string;
  values?: string[];
  version: '2';
}

export interface LiveUpdatesGatewayFeaturesQuery {
  id: string; // gatewaySerial
  type: LiveUpdatesSubscriptionType.GatewayFeatures;
  values?: string[];
  version: '2';
}

export interface LiveUpdatesInstallationFeaturesQuery {
  id: string; // installationId
  type: LiveUpdatesSubscriptionType.InstallationFeatures;
  values?: string[];
  version: '2';
}

export interface LiveUpdatesInstallationErrorsQuery {
  id: string; // installationId
  type: LiveUpdatesSubscriptionType.InstallationErrors;
  version: '1';
}

export interface LiveUpdatesSmartNoteQuery {
  id: string; // installationId
  type: LiveUpdatesSubscriptionType.SmartNote;
  version: '1';
}

export interface LiveUpdatesGatewayAggregatedStatusQuery {
  id: string; // gatewaySerial
  type: LiveUpdatesSubscriptionType.GatewayAggregatedStatus;
  version: '1';
}

export interface LiveUpdatesGatewayOnlineStatusQuery {
  id: string; // gatewaySerial
  type: LiveUpdatesSubscriptionType.GatewayOnlineStatus;
  version: '1';
}

export interface LiveUpdatesInstallationQuery {
  id: string; // installationId
  type: LiveUpdatesSubscriptionType.Installation;
  version: '1';
}

export interface LiveUpdatesInvitationQuery {
  id: string; // userId
  type: LiveUpdatesSubscriptionType.Invitation;
  version: '1';
}

export interface AggregatedStatusWebsocketResponse {
  aggregatedStatus: AggregatedStatus;
  lastChangedAt: string;
  gatewaySerial: string;
  gatewayStatus: {
    value: AggregatedStatus;
    lastChangedAt: string;
  };
  bmuStatuses: [
    {
      value: AggregatedStatus;
      lastChangedAt: string;
      deviceId: string;
    }
  ];
  boilerStatuses: [
    {
      value: AggregatedStatus;
      lastChangedAt: string;
      deviceId: string;
    }
  ];
}

export interface SmartNotesWebsocketResponse {
  note: ActiveErrorResponse;
  installationId: number;
  action: 'Created' | 'Deleted';
}

export enum WebsocketSmartNoteStatus {
  Created = 'Created',
  Deleted = 'Deleted',
}
